import React, { Component } from 'react';
import * as d3 from 'd3';

import VillagerAvatar from '../components/VillagerAvatar';
import Dialogue from '../components/Dialogue';
import TipBubble from '../components/TipBubble';


class VillagerSummary extends Component {
  constructor(props){
      super(props);
   }
  render() {
    return (
      <div ref={this.props.innerRef}  id={`villager-${this.props.step}`} className="step">
         <h2 className="title">Who are the most popular villagers?</h2>
         <p className="paragraph">We ranked the villagers based on their Popularity Score and grouped them into 10 tiers of about 40 villagers each. <a className="inline-tooltip mini" href="#" aria-label="Top 40 Villagers">Tier 1</a> represents the top ranked popular villagers, and <a className="inline-tooltip mini" href="#" aria-label="Bottom 34 Villagers">Tier 10</a> represents the least popular villagers. Because of ties, the number of villagers in each tier may differ slightly.</p>

         <Dialogue title="Note on anomalies" type="blob">
           <p className="paragraph"> There were <a className="inline-tooltip" href="#" aria-label="These villagers are a special collaboration with Sanrio and are inspired by Sanrio characters. As of April 2021, they can only be met by buying Nintendo’s Amiibo cards, so they are not tradeable on Nookazon and do not have a marketplace value."> 6 Sanrio character villagers</a> introduced to the game in a later update on Mar 18, 2021. Their rankings aren't necessarily reflective of their popularity because they only have 2 months of poll data available.</p>
         </Dialogue>

         <p className="paragraph haspointer">Let’s take a look at our top 40 most popular villagers here. As we go through our analysis, we’re going to use these Top 40 to illustrate some of the trends that we have noticed. </p>

          <TipBubble>In this article, <b>Top 40 villagers</b> means <b>Tier 1 villagers</b>, abbreviated as <b>T.1</b> on charts.</TipBubble>

      </div>
    )
  }
}

export default VillagerSummary;
